import { createSelector } from '@reduxjs/toolkit';
import { selectors as dataGridTableSelectors } from '../Modules/dataGridTable';
import { selectors as filterSelectors } from '../Modules/filters';
import { getItemOrDefaultToValue } from 'utils/details';
import isEmpty from 'lodash/isEmpty';
import { DEFAULT_EMPTY_VALUE } from 'utils/constants';

export const getTotalEntries = createSelector(
  dataGridTableSelectors.getTotalGridRows,
  rowsCount => {
    if (!rowsCount) {
      return 0;
    }
    return rowsCount;
  },
);
// status of list refresh
export const getForceRefresh = createSelector(
  dataGridTableSelectors.getForceRefresh,
  forceRefresh => forceRefresh,
);
export const getFilters = createSelector(
  filterSelectors.getFilterValues,
  filterValues => {
    return filterValues;
  },
);
export const transformList = data => {
  return data.map(item => {
    return {
      id: item?.id,
      archived: item.archived,
      category: {
        id: getItemOrDefaultToValue(item, 'category', '-'),
        icon: getItemOrDefaultToValue(item, 'categoryIcon', '-'),
        name: getItemOrDefaultToValue(item, 'category', '-'),
      },
      name: getItemOrDefaultToValue(item, 'typeName', '-'),
    };
  });
};
export const getTaskTypeList = createSelector(
  dataGridTableSelectors.getGridTableList,
  list => {
    if (isEmpty(list)) {
      return [];
    }
    return transformList(list);
  },
);
export const getTaskTypeListRaw = createSelector(
  dataGridTableSelectors.getGridTableList,
  list => {
    if (isEmpty(list)) {
      return [];
    }
    return list;
  },
);
export const transformTaskTypeDetails = data => {
  return {
    generalInfo: {
      archived: {
        type: 'boolean',
        value: getItemOrDefaultToValue(data, 'archived', '-'),
      },
      /**
       * TODO: Making it similar to other category in detail panel with only icon displaying instead of text.
       * consult with simon on how to display the categories ind etail panel
       */
      category: {
        type: 'icons',
        value: data['categoryIcon'] || DEFAULT_EMPTY_VALUE,
      },
      // taskCategory: {
      //   label: ' ',
      //   type: 'icons',
      //   value: data['categoryIcon'] || DEFAULT_EMPTY_VALUE,
      // },
      name: {
        type: 'text',
        value: getItemOrDefaultToValue(data, 'typeName', '-'),
      },
    },
  };
};
export const getTaskTypeDetailsTransformed = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  data => {
    if (!data) {
      return {};
    }
    return transformTaskTypeDetails(data);
  },
);
export const getTaskTypeDetailsRaw = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  data => {
    if (!data) {
      return {};
    }
    return data;
  },
);
